export default "__VITE_ASSET__B5qW1ZEr__"